import React, { useEffect } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { closeTrackSheetModal, fetchTrackSheet, openTrackSheetModal } from "./store/trackSheetSlice";
import TrackSheetDataTable from "./TrackSheetDataTable";

const TrackSheet = () => {
  const dispatch = useDispatch();
  const {
    data = [],
    loading = false,
    isModalOpen = false,
  } = useSelector((state) => state.trackSheetData || {});

  useEffect(() => {
    dispatch(fetchTrackSheet());
  }, [dispatch]);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Track Sheet "
            title="Dashboard"
            subtitle="Track Sheet"
            name="Import Employeer Component"
            onAddClick={() => dispatch(openTrackSheetModal())}
          />

          <TrackSheetDataTable data={data} loading={loading} />

          {/* <AddEmployeerComponent
            show={isModalOpen}
            onClose={() => dispatch(closeTrackSheetModal())}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default TrackSheet;
